/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

'file-loader?name=.htaccess!./.htaccess';
// Needed for redux-saga es6 generator support
// import '@babel/polyfill';
// Import all the third party stuff
import React from 'react';
import ReactDOM from 'react-dom';
import 'sanitize.css/sanitize.css';
import history from './utils/history';
import { Provider } from 'react-redux';
import FontFaceObserver from 'fontfaceobserver';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { ColorSchemeProvider } from './Theme/ColorScheme';
// import { initializeFirebase } from './utils/push-notification';

// Import root app
import App from './containers/App';

// Import Language Provider
import LanguageProvider from './containers/LanguageProvider';

// Load the favicon and the .htaccess file
/* eslint-disable import/no-unresolved, import/extensions */

import configureStore from './configureStore';

// Import i18n messages
import { translationMessages } from './i18n';
import Config from './constants/config';

// Observe loading of Roboto (to remove roboto, remove the <link> tag in
// the index.html file and this observer)
const openSansObserver = new FontFaceObserver('Roboto', {});

// When Roboto is loaded, add a font-family using Roboto to the body
openSansObserver.load().then(() => {
    document.body.classList.add('fontLoaded');
});

// Create redux store with history
const initialState = {};
export const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('root');

if (Config.logsDisable) {
    console.log = () => {};
    console.error = () => {};
    console.warn = () => {};
}

const render = (messages) => {
    ReactDOM.render(
        <Provider store={store}>
            <LanguageProvider messages={messages}>
            <ColorSchemeProvider>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </ColorSchemeProvider>   
            </LanguageProvider>
        </Provider>,
        MOUNT_NODE,
    );
    // initializeFirebase();
};

if (module.hot) {
    // Hot reloadable React components and translation json files
    // modules.hot.accept does not accept dynamic dependencies,
    // have to be constants at compile-time
    module.hot.accept(['./i18n', './containers/App'], () => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render(translationMessages);
    });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
    new Promise((resolve) => {
        resolve(import('intl'));
    })
        .then(() => Promise.all([import('intl/locale-data/jsonp/en.js')]))
        .then(() => render(translationMessages))
        .catch((err) => {
            throw err;
        });
} else {
    render(translationMessages);
}

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
// if (process.env.NODE_ENV === 'production') {
//     require('offline-plugin/runtime').install(); // eslint-disable-line global-require
// }
